import { AppBar, Typography, Toolbar, Button, makeStyles } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signOut } from "../../store/actions/authActions";

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    linkStyle: {
        color: '#fafafa',
        textDecoration: 'none',
    },
    authButton: {

    }
});

const NavBar = () => {
    const classes = useStyles();
    const state = useSelector((state) => state);
    const auth = useSelector((state) => state.auth);
    const history = useHistory();
    const dispatch = useDispatch();

    const handleSignOut = () => {
        dispatch(signOut());
        history.push('/sign-in');
    }

    return (
        <>
            <AppBar position="static" >
                <Toolbar>
                    <Typography variant="h4" className={classes.root}>
                        <Link to="/" className={classes.linkStyle}>
                            Todo App
                        </Link>
                    </Typography>

                    {
                        auth._id ?
                            (
                                <>
                                    <Typography variant="subtitle2" className={classes.root}>
                                        Logged in as {auth.name}
                                    </Typography>
                                    <Button
                                        color="inherit"
                                        onClick={() => handleSignOut()}
                                    >
                                        Sign Out
                                    </Button>
                                </>
                            ) :
                            (
                                <>
                                    <Button
                                        color="inherit"
                                    >
                                        <Link to="/sign-in" className={classes.linkStyle}>
                                            Sign In
                                        </Link>
                                    </Button>
                                    <Button
                                        color="inherit"
                                    >
                                        <Link to="/sign-up" className={classes.linkStyle}>
                                            Sign Up
                                        </Link>
                                    </Button>
                                </>
                            )
                    }
                </Toolbar>
            </AppBar>
        </>
    );
}

export default NavBar;